
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class PrivacyPolicyView extends Vue {}
